import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../../shared/shared.module';
import { ProposalRoutingModule } from './proposal.routing.module';
import { ProposalService } from './proposal.service';
import { ProposalGridComponent } from './proposal-grid/proposal-grid.component';
import { ProductCatalogModule } from '../product-catalog/product-catalog.module';
import { ProposalPopupComponent } from './proposal-popup/proposal-popup.component';
import { ItemsGridComponent } from './proposal-popup/items-grid/items-grid.component';
import { PackagesGridComponent } from './proposal-popup/packages-grid/packages-grid.component';
import { InstallationChargesPopupComponent } from './proposal-popup/installation-charges-popup/installation-charges-popup.component';
import { ShippingChargesPopupComponent } from './proposal-popup/shipping-charges-popup/shipping-charges-popup.component';
import { InstallerPopupComponent } from './proposal-popup/installer-popup/installer-popup.component';
import { ShippingAddressAdvancedSearchPopupComponent } from './proposal-popup/shipping-address-advanced-search-popup/shipping-address-advanced-search-popup.component';
import { ItemWarningsPopupComponent } from './proposal-popup/item-warnings-popup/item-warnings-popup.component';
import { ItemShowStoppersPopupComponent } from './proposal-popup/item-showstoppers-popup/item-showstoppers-popup.component';
import { ShippingChargesAccessPopupComponent } from './proposal-popup/shipping-access-charges-popup/shipping-access-charges-popup.component';
import { RevisionDetailsPopupComponent } from './proposal-popup/revision-details-popup/revision-details-popup.component';
import { OnholdDetailsPopupComponent } from './proposal-popup/onhold-details-popup/onhold-details-popup.component';
import { ProposalMainGridComponent } from './proposal-main-grid/proposal-main-grid.component';
import { AttachmentsComponent, HistoryComponent } from 'projects/shared/src/public-api';
import { SalesOrderModule } from '../sales-order/sales-order.module';
import { LinksComponent } from 'projects/sales/src/app/shared/components/links/links.component'
import { ButtonBannerComponent } from '../../shared/components/button-banner/button-banner.component';
import { FinancePopupsComponent } from '../../shared/components/finance-popups/finance-popups.component';
import { LeasingPartnersPopupComponent } from '../../shared/components/finance-popups/leasing-partners-popup/leasing-partners-popup.component';

@NgModule({
  declarations: [
    ProposalGridComponent,
    ProposalPopupComponent,
    ItemsGridComponent,
    PackagesGridComponent,
    InstallationChargesPopupComponent,
    ShippingChargesPopupComponent,
    InstallerPopupComponent,
    ShippingAddressAdvancedSearchPopupComponent,
    ItemWarningsPopupComponent,
    ItemShowStoppersPopupComponent,
    ShippingChargesAccessPopupComponent,
    RevisionDetailsPopupComponent,
    OnholdDetailsPopupComponent,
    ProposalMainGridComponent
  ],
  imports: [
    ProposalRoutingModule,
    CommonModule,
    SharedModule,
    ProductCatalogModule,
    LinksComponent,
    AttachmentsComponent,
    HistoryComponent,
    ButtonBannerComponent,
    FinancePopupsComponent,
    LeasingPartnersPopupComponent
  ],
  exports: [
    ProposalGridComponent
  ],
  providers: [ProposalService]
})
export class ProposalModule { }
